export { default } from './RefundPolicy';
